import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Original root-site URL — permanently redirect to the /locations child page.
export const Route = createFileRoute("/restore-west")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/locations/restore-west/", location.searchStr), statusCode: 301 });
  },
});
